import { render, staticRenderFns } from "./Variant5.vue?vue&type=template&id=6c158b1d&"
import script from "./Variant5.vue?vue&type=script&lang=js&"
export * from "./Variant5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports